const train = [{
  desc: '查询培训立项',
  options: {
    url: '/trainingConstructionProjects/page',
    method: 'post'
  }
}, {
  desc: '添加培训立项',
  options: {
    url: '/trainingConstructionProjects/add',
    method: 'post'
  }
}, {
  desc: '删除培训立项',
  options: {
    url: '/trainingConstructionProjects/delete',
    method: 'delete'
  }
}, {
  desc: '更新培训立项',
  options: {
    url: '/trainingConstructionProjects/update',
    method: 'put'
  }
}, {
  desc: '查询培训计划',
  options: {
    url: '/trainingPlan/page',
    method: 'post'
  }
}, {
  desc: '添加培训计划',
  options: {
    url: '/trainingPlan/add',
    method: 'post'
  }
}, {
  desc: '更新培训计划',
  options: {
    url: '/trainingPlan/update',
    method: 'put'
  }
}, {
  desc: '查询培训班',
  options: {
    url: '/trainingClass/page',
    method: 'post'
  }
}, {
  desc: '删除培训班',
  options: {
    url: '/trainingClass/delete',
    method: 'delete'
  }
}, {
  desc: '删除培训计划',
  options: {
    url: '/trainingPlan/delete',
    method: 'delete'
  }
}, {
  desc: '添加培训班',
  options: {
    url: '/trainingClass/add',
    method: 'post'
  }
}, {
  desc: '获取所有的培训班',
  options: {
    url: '/trainingClass/queryAllTrainingClass',
    method: 'get'
  }
}, {
  desc: '获取所有的培训计划',
  options: {
    url: '/trainingPlan/queryAllTrainingPlan',
    method: 'get'
  }
}, {
  desc: '获取所有的培训讲师',
  options: {
    url: '/trainingLecturer/queryAllTrainingLecturer',
    method: 'get'
  }
}, {
  desc: '获取所有的培训课程',
  options: {
    url: '/trainingCurriculum/queryAllTrainingCurriculum',
    method: 'get'
  }
}, {
  desc: '更新培训班',
  options: {
    url: '/trainingClass/update',
    method: 'put'
  }
}, {
  desc: '查询培训结果',
  options: {
    url: '/trainingResults/page',
    method: 'post'
  }
}, {
  desc: '更新培训结果',
  options: {
    url: '/trainingResults/update',
    method: 'put'
  }
}, {
  desc: '删除培训结果',
  options: {
    url: '/trainingResults/delete',
    method: 'delete'
  }
}, {
  desc: '统计查询',
  options: {
    url: '/trainingStatistics/queryStatistics',
    method: 'post'
  }
}, {
  desc: '查询培训讲师',
  options: {
    url: '/trainingLecturer/page',
    method: 'post'
  }
}, {
  desc: '添加培训讲师',
  options: {
    url: '/trainingLecturer/add',
    method: 'post'
  }
}, {
  desc: '更新培训讲师',
  options: {
    url: '/trainingLecturer/update',
    method: 'put'
  }
}, {
  desc: '删除培训讲师',
  options: {
    url: '/trainingLecturer/delete',
    method: 'delete'
  }
}, {
  desc: '查询培训课程',
  options: {
    url: '/trainingCurriculum/page',
    method: 'post'
  }
}, {
  desc: '添加培训课程',
  options: {
    url: '/trainingCurriculum/add',
    method: 'post'
  }
}, {
  desc: '批量删除',
  options: {
    url: '/trainingCurriculum/batchRemove',
    method: 'post'
  }
}, {
  desc: '删除培训课程',
  options: {
    url: '/trainingCurriculum/delete',
    method: 'delete'
  }
}, {
  desc: '删除培训课程',
  options: {
    url: '/trainingCurriculum/update',
    method: 'put'
  }
}, {
  desc: '培训计划导入',
  options: {
    url: '/trainingPlan/importTrainingConstructionProject',
    method: 'put'
  }
}, {
  desc: '小鹅通注册用户',
  options: {
    url: '/sysSales/registerXiaoeUser',
    method: 'post'
  }
}, {
  desc: '培训学时记录列表',
  options: {
    url: '/sysSales/getTrainingHoursRecords',
    method: 'post'
  }
}, {
  desc: '培训学时记录详情列表',
  options: {
    url: '/sysSales/getTrainingHoursRecordDetails',
    method: 'post'
  }
}, {
  desc: '培训种类枚举获取接口',
  options: {
    url: '/sysSales/queryTrainingTypes',
    method: 'post'
  }
}]
export default train



// WEBPACK FOOTER //
// ./src/api/train.js